import './Badge.scss';

export function Badge(props) {
    return <div className={props.className + " Badge"} style={props.style}>
        {props.children}
    </div>
}